// TODO: Move to forms-shared

export const LOCATION_TYPE_DOCUMENT = 'document';
export const LOCATION_TYPE_LOCAL_FILE = 'localfile';
